<script>
import { Component, Prop, Vue } from "vue-property-decorator";
import { truncateString } from '@/filters';

@Component({
    filters: { truncateString }
})
export default class UserWithBadge extends Vue {
    @Prop({ type: String, required: true }) fullName;
    @Prop({ type: String, default: "" }) initials;
    @Prop({ type: String, required: true }) badgeClass;
    @Prop({ type: Boolean, default: false }) removed;
	@Prop({ type: Boolean, default: false }) isAdhoc;

    maxTruncatingCharacters = 30;
}
</script>
<template>
    <div :class="['spacing', { 'disabled': removed }]"  :title="fullName">
        <div
            class="circle small"
            :class="badgeClass"
            data-cy="user-initials-badge"
        >
            <span data-cy="user-initials">{{ initials }}</span>
        </div>
        <span
            :class="{ 'disabled-text': removed }"
            data-cy="user-fullname"
        >
			<span
                v-if="isAdhoc"
                data-cy="user-adhoc-prefix"
            >
                [Ad Hoc]&nbsp;
            </span>
            {{ fullName |  truncateString(maxTruncatingCharacters) }}
            <span
                v-if="removed"
                data-cy="user-removed-suffix"
            >
                &nbsp;(Removed)
            </span>
        </span>
    </div>
</template>

<style scoped lang="scss">
.spacing {
    padding: 2px 0px;
}

.disabled-text {
    color: #666;
}
</style>
